import type { BenefitsIncome } from '@/types/AddIncome'

import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import IncomePropertiesInput from './IncomePropertiesInput'

interface Props {
  income: BenefitsIncome
  propertyDispatch: PropertyDispatch
}

const BenefitsInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  return (
    <div>
      <IncomePropertiesInput
        incomeProperties={income.incomeProperties}
        propertyDispatch={propertyDispatch}
        amountProperty={Property.IncomeAmount}
        frequencyProperty={Property.IncomeFrequency}
      />
    </div>
  )
}

export default BenefitsInput
